import { Injectable, inject } from '@angular/core';

import { GeneralService } from 'app/services/data/general.service';
import { Observable } from 'rxjs';

@Injectable()

export class ContentResolver  {
    private generalService = inject(GeneralService);

    resolve(): Observable<boolean> {
        return this.generalService.fetchData$();
    }
}
